// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-container--QjN1K{color:#f0f0f4}.footer-container--QjN1K .section-footer--hjU7f{margin-bottom:0;background-color:#1b1f25;border-radius:0}.footer-container--QjN1K .section-footer--hjU7f .logo-box--gAEH1{max-width:320px}.footer-container--QjN1K .footer-header--Gjz7L{font-weight:600}.footer-container--QjN1K .footer-links--OYUA8{padding:0;list-style-type:none}.footer-container--QjN1K .footer-links--OYUA8 a{color:#b4bccd}.footer-container--QjN1K .footer-links--OYUA8 hr{border-top:1px solid #48505e}.footer-container--QjN1K .logo-image--bEbod{max-width:120px}.footer-container--QjN1K .copyright--Cw0jz{background-color:#1b1b1b}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-container": "footer-container--QjN1K",
	"section-footer": "section-footer--hjU7f",
	"logo-box": "logo-box--gAEH1",
	"footer-header": "footer-header--Gjz7L",
	"footer-links": "footer-links--OYUA8",
	"logo-image": "logo-image--bEbod",
	"copyright": "copyright--Cw0jz"
};
export default ___CSS_LOADER_EXPORT___;
